// Milestone event-log strings — English. Merged in ./messages.ts.

export const gameMilestonesEn = {
  'event.milestone.city.first_founded': 'New city founded',
  'event.milestone.city.tier_up': 'City grew',
  'event.milestone.city.first_capture': 'First city captured',
  'event.milestone.city.capital_captured': 'Capital captured',
  'event.milestone.hero.first_recruited': 'First hero recruited',
  'event.milestone.hero.level_milestone': 'Hero levelled up',
  'event.milestone.doctrine.tier_reached': 'Doctrine tier reached',
  'event.milestone.faith.temple_built': 'First temple built',
  'event.milestone.wonder.built': 'Wonder built',
  'event.milestone.magic.ritual_completed': 'Ritual completed',
  'event.milestone.diplomacy.peace_signed': 'Peace signed',
  'event.milestone.battle.decisive': 'Decisive battle',
  'event.milestone.era.advanced': 'A new era',
  'event.milestone.victory.achieved': 'Victory achieved',
  'event.milestone.graduation.new_rule': 'New rule unlocked',
  'event.milestone.sea.merchant_route': 'Trade route opened',
  'event.milestone.unknown': 'Milestone',
  'event.detail.milestone': 'Player {player}',
  'event.detail.milestoneName': 'Player {player} — {name}',
  'event.detail.milestoneTier': 'Player {player} — now a {tier}',
  'event.detail.milestoneLevel': 'Player {player} — level {level}',
  'event.detail.milestoneEra': 'Player {player} — era {era}',
  'event.detail.milestoneWith': 'Player {player} — with Player {other}',
  'event.milestone.tier.2': 'town',
  'event.milestone.tier.3': 'city',
  'event.milestone.tier.4': 'metropolis',
  'event.milestone.tier.5': 'megacity',
} as const;
